import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export const useStyles = makeStyles(({
  fontWeights, breakpoints,
}: Theme) => ({
  title: {
    maxWidth: '12.5rem',
    margin: '0 auto',
    padding: 0,
    fontWeight: fontWeights.medium,
    textAlign: 'center',
    [breakpoints.up('md')]: {
      maxWidth: 'unset',
    },
    '& h2': {
      fontSize: '1.25rem',
      lineHeight: 1.5,
    },
  },
  paper: {
    width: '20.5rem',
    maxWidth: '98%',
    borderRadius: '0.25rem',
    [breakpoints.up('md')]: {
      width: '27.8125rem',
      paddingTop: '2.5rem',
      paddingBottom: '2.5rem',
    },
  },
  content: {
    marginTop: '0.5rem',
    fontSize: '0.875rem',
    lineHeight: 1.5,
    textAlign: 'center',
  },
}));
